// Formatos de presentación compartidos (se registran como filtros globales en main.js)

const BRAND_CASE = {
  fedex: "FedEx",
  dhl: "DHL",
  ups: "UPS",
  ptx: "PTX",
  epak: "Epak",
  afimex: "Afimex",
  bigsmart: "BigSmart",
  paquetexpress: "Paquetexpress",
  tresguerras: "Tresguerras",
  estafeta: "Estafeta",
  entrega: "Entrega",
  ltl: "LTL",
  mx: "MX",
};

const titleWord = (word) => {
  const lower = word.toLowerCase();
  if (BRAND_CASE[lower]) return BRAND_CASE[lower];
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

const isEmpty = (value) =>
  value === null || value === undefined || value === "" || value === "null" || value === "undefined";

// 1632.8 -> "$1,632.80 MXN"
export function money(value, currency = "MXN") {
  if (isEmpty(value) || isNaN(Number(value))) return "—";
  const formatted = Number(value).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  });
  return currency ? `${formatted} ${currency}` : formatted;
}

// "Fedex_international_priority" / "FEDEX_EXPRESS_SAVER" -> "FedEx International Priority"
export function serviceName(value) {
  if (isEmpty(value)) return "—";
  return String(value)
    .replace(/_/g, " ")
    .trim()
    .split(/\s+/)
    .map(titleWord)
    .join(" ");
}

// "PAQUETEXPRESS" -> "Paquetexpress", "FEDEX" -> "FedEx"
export function carrierName(value) {
  if (isEmpty(value)) return "—";
  return serviceName(value);
}

// null / "null" / "" -> "—"
export function dash(value) {
  return isEmpty(value) ? "—" : value;
}

// Estatus de rastreo: las paqueterías (sobre todo FedEx/UPS/DHL) los devuelven en
// inglés. Se traducen por coincidencia de palabras clave y se clasifican en un tono
// para pintarlos: created | transit | delivery | delivered | issue | cancelled.
const TRACKING_RULES = [
  { re: /cancel/i, label: "Envío cancelado", tone: "cancelled" },
  { re: /return(ed)? to (sender|shipper)|retorno|devuel/i, label: "Retorno a remitente", tone: "issue" },
  { re: /^delivered|entregado/i, label: "Entregado", tone: "delivered" },
  { re: /exception|incidencia|delay|retras|damage|refused|rechaz|clearance delay/i, label: null, tone: "issue" },
  { re: /attempt|intento/i, label: "Intento de entrega", tone: "issue" },
  { re: /out for delivery|on .* vehicle for delivery|en ruta (para|de) entrega/i, label: "En ruta para entrega", tone: "delivery" },
  { re: /ready for (pickup|recogida)|available for pickup|hold at location|disponible para ser recolectado|ocurre/i, label: "Disponible en sucursal", tone: "delivery" },
  { re: /label created|shipment information sent|shipment ready|envío creado|guía generada|pre-?transit/i, label: null, tone: "created" },
  { re: /picked up|recolectado|recolección/i, label: "Recolectado", tone: "transit" },
  { re: /in transit|en tránsito|en transito|departed|arrived|at (local )?.*facility|on the way|processed|clearance|left|en camino|llegó|salió/i, label: null, tone: "transit" },
];

const TRACKING_EXACT = {
  "label created": "Guía creada",
  "shipment information sent to fedex": "Información enviada a la paquetería",
  "shipment information sent": "Información enviada a la paquetería",
  "picked up": "Recolectado",
  "in transit": "En tránsito",
  "departed fedex location": "Salió de la instalación",
  "arrived at fedex location": "Llegó a la instalación",
  "at local fedex facility": "En instalación local",
  "at destination sort facility": "En centro de distribución destino",
  "on fedex vehicle for delivery": "En ruta para entrega",
  "out for delivery": "En ruta para entrega",
  "delivered": "Entregado",
  "delivery exception": "Incidencia en la entrega",
  "clearance delay": "Retraso en aduana",
  "international shipment release - import": "Liberado en aduana",
  "shipment exception": "Incidencia en el envío",
  "delay": "Retraso",
  "shipment cancelled by sender": "Cancelado por el remitente",
  "shipment canceled by sender": "Cancelado por el remitente",
};

export function trackingStatus(value) {
  if (isEmpty(value) || value === "-") return { label: "Sin movimientos", tone: "none" };
  const text = String(value).trim();
  const exact = TRACKING_EXACT[text.toLowerCase()];
  const rule = TRACKING_RULES.find((r) => r.re.test(text));
  const tone = rule ? rule.tone : "transit";
  let label = exact || (rule && rule.label) || text;
  if (!exact && /[a-z]/i.test(text) && /\b(the|at|to|for|in|on|of|and)\b/i.test(text) && rule && !rule.label) {
    // Texto en inglés sin traducción exacta: se usa la etiqueta genérica del tono
    label = { created: "Guía creada", transit: "En tránsito", issue: "Incidencia" }[tone] || text;
  }
  return { label, tone };
}

// Descripción de un evento de rastreo: se traduce si la conocemos; si viene en
// inglés y no la conocemos, se omite (el estatus traducido ya dice lo esencial).
export function trackingDescription(description, status) {
  if (isEmpty(description)) return "";
  const text = String(description).trim();
  const known = TRACKING_EXACT[text.toLowerCase()];
  const result = known || (/\b(the|to|by|at|for|from|has|was|is|your|package|shipment)\b/i.test(text) ? "" : text);
  return result && result !== trackingStatus(status).label ? result : "";
}

export default { money, serviceName, carrierName, dash, trackingStatus, trackingDescription };



// WEBPACK FOOTER //
// ./src/utils/format.js